import { type FC } from 'react';

import { AssignedTo } from '@features/assigned_to';
import { TagsList } from '@features/marketplace';

import { Box, Flex } from '@shared/ui-kit';

interface Props {
  id: string;
  assignedTo: string | null;
  assignedFullName: string | null;
  tags: string[] | null;
}

const CardFooter: FC<Props> = (props) => {
  const { id, assignedTo, assignedFullName, tags } = props;

  return (
    <Flex
      alignItems="flex-end"
      justifyContent="space-between"
    >
      {tags && (
        <Box className="fg-of-link">
          <TagsList tags={tags} />
        </Box>
      )}
      <Box className="fg-of-link">
        <AssignedTo
          merchantId={id}
          assignedTo={assignedTo}
          assignedFullName={assignedFullName}
        />
      </Box>
    </Flex>
  );
};

export default CardFooter;
